<template>
  <v-card class="mx-auto mb-0 mt-n3">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel key="0">
        <v-expansion-panel-header>
          {{ $t("membershipChange") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <memberships :isRadioButtonsDisabled=true />
            <br/>
            <v-row>
              <v-col style="padding-top: 0; padding-bottom: 0">
                <p>{{ $t("availabilityOfExtraConnections") }} ${{ CONNECTIONS_OVER_MEMBERSHIP.price }}
                  {{ $t("availabilityOfExtraConnectionsEach") }} </p>
              </v-col>
            </v-row>

            <v-row style="margin-top: 0">
              <v-col :sm="12" cols="12">
                <v-form class="d-flex">
                  <v-spacer/>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div style="height: 33px" v-bind="attrs" v-on="on">
                        <v-btn
                            style="margin-top: 2px"
                            class="ml-3"
                            @click="buttonClicked"
                            :loading="isButtonLoading"
                        >
                          {{ $t("buttons.changeMembership") }}
                          <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                          </template>
                        </v-btn>
                      </div>
                    </template>
                    <span> {{ $t("toolTips.changeMembership") }} </span>
                  </v-tooltip>
                  <v-spacer/>
                </v-form>
              </v-col>
            </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-snackbar right top app color="error" v-model="getCustomerPortalLinkError">
      {{ $t("notificationSnackbars.cannotLoadCustomerPortalLink") }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="getCustomerPortalLinkError = false">
          {{ $t("buttons.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import {CONNECTIONS_OVER_MEMBERSHIP} from "../../enums/membership/typeOfMembership.js";
// EventBus is defined in timer2ticket-client-vue project
import {EventBus} from "@/EventBus";
import Memberships from "./withoutMembership/Memberships.vue";
import {getCustomerPortalLink} from "../../backendService.js";

export default {
  computed: {
    CONNECTIONS_OVER_MEMBERSHIP() {
      return CONNECTIONS_OVER_MEMBERSHIP
    }
  },
  components: {Memberships},
  data() {
    return {
      panel: [],
      isButtonLoading: false,
      getCustomerPortalLinkError: false,

    };
  },
  created() {
    EventBus.$on("membership-change-open", () => {
      this.panel = [0];
    });
  },
  methods: {
    async buttonClicked() {
      this.isButtonLoading = true;
      const response = await getCustomerPortalLink("/profile/membership", "subscription_update");
      if (!response) {
        this.getCustomerPortalLinkError = true;
        // Stop showing loading button only when there is an error (no redirect)
        this.isButtonLoading = false;
      } else {
        window.location.href = response;
      }
    }
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
